import { render, staticRenderFns } from "./1000.vue?vue&type=template&id=84a71fca&scoped=true&"
import script from "./1000.vue?vue&type=script&lang=js&"
export * from "./1000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a71fca",
  null
  
)

export default component.exports